import { Component, OnInit, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { AuthTokenService } from '../../services/auth-token.service';
import { TranslationService } from '../../services/translation.service';
import { injectCurrentContext } from '../../context/auth-context';
import { TranslatePipe } from '../pipes/translate.pipe';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  //readonly currentUser = injectCurrentUser();
  private readonly authService = inject(AuthService);
  private readonly authTokenService = inject(AuthTokenService);
  private readonly router = inject(Router);
  private readonly translationService = inject(TranslationService);
  readonly currentContext = injectCurrentContext();
  readonly language = this.translationService.language;
  userName: string = '';
  role: string = '';

  constructor() {
    effect(() => {
      this.userName = this.currentContext()?.userName ?? '';
      this.role = this.currentContext()?.role ?? '';
    });
  }

  ngOnInit(): void {
    // this.authService.getCurrentUser().subscribe({
    //   error: () => this.authService.logout().subscribe()
    // });
  }

  logout(): void {
    const isNsc = this.role === 'nsc';
    const redirectToPortal = () => this.authTokenService.logout(isNsc ? 'nsc' : 'dealer');
    this.authService.logout().subscribe({
      complete: redirectToPortal,
      error: redirectToPortal
    });
  }

  /** Switches the application language; all `t` pipe labels re-render immediately. */
  selectLanguage(language: 'fr' | 'en'): void {
    this.translationService.selectLanguage(language);
  }
}
